import { USER_LOGGED_IN_UPDATED, ACCOUNT_BLOCKS_UPDATED, ACCOUNT_BLOCKS_QUERY, ACCOUNT_REQUIRES_VERIFICATION_UPDATED, ACCOUNT_REQUIRES_VERIFICATION_QUERY, ACCOUNT_USER_VERIFICATION_OVERRIDE } from '@gig/magic-messages';
import { magic } from '@gig/magic-sdk';
import { ActiveBlockReasonId } from '@gig/magic-sdk/dist/adapter/users/getUserActiveBlocks';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class AccountService {
  constructor() {
    this.isLoggedIn = false;
    this.blocks = [];
    this.requiresVerification = false;
    this.subscriptions = [];
    this.requiresVerificationSubscription = null;
    this.accountBlocksSubscription = null;
    this.loading = false;
    this.accountHandler = () => __async(this, null, function* () {
      if (this.loading) {
        return;
      }
      this.unsubscribeQueries();
      try {
        this.loading = true;
        yield this.updateUserBlocks();
        this.publishBlocksAndRequiresVerification();
      } catch (e) {
        console.log("unable to update user block", e);
      } finally {
        this.loading = false;
        this.subscribeToQueries();
      }
    });
    this.registerEvents();
    this.subscribeToEvents();
    this.overrideUserVerificationFlag();
  }
  subscribeToEvents() {
    window.eventBus.subscribe(USER_LOGGED_IN_UPDATED, (e) => __async(this, null, function* () {
      this.isLoggedIn = !!e.payload;
      if (this.isLoggedIn) {
        this.subscribeToMagicEvents();
        yield this.accountHandler();
      } else {
        this.clearMagicSubscriptions();
        this.blocks = [];
        this.requiresVerification = false;
        this.publishBlocksAndRequiresVerification();
        this.subscribeToQueries();
      }
    }), { replay: true });
  }
  registerEvents() {
    window.eventBus.register(ACCOUNT_BLOCKS_UPDATED, {
      type: "array"
    });
    window.queryBus.register(ACCOUNT_BLOCKS_QUERY, {
      type: "array"
    });
    window.eventBus.register(ACCOUNT_REQUIRES_VERIFICATION_UPDATED, {
      type: "boolean"
    });
    window.queryBus.register(ACCOUNT_REQUIRES_VERIFICATION_QUERY, {
      type: "boolean"
    });
    window.commandBus.register(ACCOUNT_USER_VERIFICATION_OVERRIDE, {
      type: "boolean"
    });
  }
  clearMagicSubscriptions() {
    this.subscriptions.forEach((unsub) => unsub());
    this.subscriptions = [];
  }
  subscribeToMagicEvents() {
    this.subscriptions.push(magic.events.firstDeposit(this.accountHandler).unsub, magic.events.userBlockStatusChanged(this.accountHandler).unsub);
  }
  updateUserBlocks() {
    return __async(this, null, function* () {
      this.blocks = yield magic.methods.users.getUserActiveBlocks();
      this.requiresVerification = this.blocks.some(({ blockReasonId }) => blockReasonId === ActiveBlockReasonId.UserNotVerified);
    });
  }
  publishBlocksAndRequiresVerification() {
    window.eventBus.publish(ACCOUNT_REQUIRES_VERIFICATION_UPDATED, this.requiresVerification);
    window.eventBus.publish(ACCOUNT_BLOCKS_UPDATED, this.blocks);
  }
  overrideUserVerificationFlag() {
    window.commandBus.subscribe(ACCOUNT_USER_VERIFICATION_OVERRIDE, (event) => {
      this.requiresVerification = !!event.payload;
      this.publishBlocksAndRequiresVerification();
    });
  }
  subscribeToQueries() {
    if (!this.requiresVerificationSubscription) {
      this.requiresVerificationSubscription = window.queryBus.subscribe(ACCOUNT_REQUIRES_VERIFICATION_QUERY, () => {
        return this.isLoggedIn && this.requiresVerification;
      });
    }
    if (!this.accountBlocksSubscription) {
      this.accountBlocksSubscription = window.queryBus.subscribe(ACCOUNT_BLOCKS_QUERY, () => {
        return this.blocks;
      });
    }
  }
  unsubscribeQueries() {
    var _a, _b;
    (_a = this.requiresVerificationSubscription) == null ? void 0 : _a.unsubscribe();
    this.requiresVerificationSubscription = null;
    (_b = this.accountBlocksSubscription) == null ? void 0 : _b.unsubscribe();
    this.accountBlocksSubscription = null;
  }
}

export { AccountService };
